import { css, jsx } from '@emotion/core';
import React from 'react';

import CeoCommunication from '@/src/ceoComminucations/components/CeoCommunication';

const style = {
  bottomDivPad: css`
  padding-bottom: 20px;
  `,
}

const CeoCommunicationsList = ({ data }) => {
  return(
    <>
      {data.length ? (
        (data)
        .map(items => (
          <div css={style.bottomDivPad}>
            <CeoCommunication data={items} />
          </div>
        ))
      ) : (
        <div>
            No Data Available
        </div>
      )}
    </>
  )
}

export default CeoCommunicationsList;

